import React, { useState, useEffect } from 'react'
import { Card, CardBody } from 'reactstrap'

import ListTopBar from '../../components/ListTopBar'

import NewSstPostModal from './partials/NewSstPostModal'
import SstPostsTable from './partials/SstPostsTable'

import { handleError, parsePagination } from '../../helpers'
import { getSstPosts } from './services'

export default function SstPostsList() {
	const [sstPosts, setSstPosts] = useState(null)
	const [filterType, setFilterType] = useState('name')
	const [filterValue, setFilterValue] = useState('')
	const [pagination, setPagination] = useState({page: 1, per_page: 15, total: 0})
	const [showNewModal, setShowNewModal] = useState(false)

	useEffect(() => {
		!sstPosts && getSstPosts({
			...pagination,
			[`filter[${filterType}]`]: filterValue,
			include: 'user,categories,tags,opensCount,departments',
			sort: '-created_at',
		})
			.then(res => {
				setSstPosts(res.data.data)
				setPagination(parsePagination(res))
			})
			.catch(error => handleError(error))
	}, [ sstPosts, pagination, filterType, filterValue ])

	return (
		<React.Fragment>
			<ListTopBar 
				title="Publicaciones SST"
				subtitle="Listado de todas las publicaciones SST publicadas en la plataforma"
				filterType={filterType}
				setFilterType={setFilterType}
				filterValue={filterValue}
				setFilterValue={setFilterValue}
				reload={() => setSstPosts(null)}
				options={[
					{ label: 'Buscar por titulo', value: 'name' },
					{ label: 'Buscar por descripción corta', value: 'excerpt' },
					{ label: 'Buscar por contenido', value: 'description' },
				]}
				ctaText="Agregar Publicación SST"
				handleCtaClick={() => setShowNewModal(true)}
			/>
			<Card>
				<CardBody>
					<SstPostsTable 
						sstPosts={sstPosts}
						reload={() => setSstPosts(null)}
						pagination={pagination}
						setPagination={setPagination}
					/>
				</CardBody>
			</Card>
			{ showNewModal && (
				<NewSstPostModal 
					visible
					onClose={() => setShowNewModal(false)}
					reload={() => {
						setSstPosts(null)
						setShowNewModal(false)
					}}
				/>
			)}
		</React.Fragment>
	)
}